import { render, staticRenderFns } from "./MobileDetail.vue?vue&type=template&id=4dfed48a&"
import script from "./MobileDetail.vue?vue&type=script&lang=js&"
export * from "./MobileDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports